import ptBr from './error-boundary.translations.ptBr.json';

export default {
  'pt-BR': ptBr,
  en: {}
};
